export default __webpack_public_path__ + "static/sc-trade-4e027c9500988bf101aa95b732586a22.webp";